<template>
 
  <div class="container">

    <div class="row" id="media">

        <div class="col-lg-8 mt-0">
            <h2 class="h3">{{ $t("contacts_title") }}</h2>
            <p class="ontario-lead-statement mb-0">{{ $t("contacts_description") }}</p>
        </div><!-- col-lg-8 -->
       
        <hr class="bold_hr_super ml-3 mr-3">

    </div><!-- row -->

    <section v-if="errored">
        <p>{{ $t("message_error") }}</p>
    </section>

    <section v-else>
      
      <div class="row">

        <div class="col-lg-7">

          <div v-if="loading">Loading...</div>

          <div class="contact_container" v-else>
              
              <!-- Media contacts -->
              <div v-for="ministry in mediaContacts" v-bind:key="ministry.ministry_id">
                  <h3 class="ut-mn h4 mb-0">{{ ministry.name }}</h3>
                  <div class="row">
                    <div class="col-md-6 mt-4" v-for="contact in ministry.contacts">
                      <p class="ut-cn font-weight-bold mb-1" v-if="contact.name">{{ contact.name }}</p>
                      <p class="ut-cn font-weight-bold mb-1" v-if="contact.generic_name">{{ contact.generic_name }}</p>
                      <p class="mb-0">{{ contact.title }}</p>
                      <p class="ut-cp mb-0" v-if="contact.phone_number">
                        <a :href="'tel:' + contact.phone_number">{{ contact.phone_number }}</a>
                      </p>
                      <p class="ut-cd mb-0" v-if="contact.email">
                        <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
                      </p>
                    </div><!-- col-lg-4 -->
                  </div><!-- row -->
                <hr />
              </div>

          </div>

        </div><!-- col-lg-8 -->

        <div class="col-lg-4 offset-lg-1">

          <h3 class="h4">{{ $t("advisories_latest_title") }}</h3>
          <advisories :pagination="false" :type="2002" :limit="3" :page="1"></advisories>

        </div><!-- col-lg-4 -->

      </div><!-- row -->

    </section>

  </div>

</template>

<script>
import Advisories from '../components/Advisories.vue'

export default {
  props: ['language'],
  components: {
    Advisories
  },
  data () {
    return {
      mediaContacts: null,
      loading: false,
      errored: false,
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'contacts', {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          this.mediaContacts = response.data.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
